"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_hooks_1 = require("@apollo/react-hooks");
const graphql_1 = require("../../graphql");
exports.useEmailTemplateVersion = ({ emailTemplateId, emailTemplateVersionId, skip, }) => {
    return react_hooks_1.useQuery(graphql_1.emailTemplateVersion, {
        skip,
        // skip: !match.params.versionId || !emailTemplateId,
        // fetchPolicy: 'cache-and-network',
        variables: {
            emailTemplateId,
            id: emailTemplateVersionId,
        },
    });
};
//# sourceMappingURL=useEmailTemplateVersion.js.map